import React, { useState, useEffect } from "react";
import { View, Text, Button, Pressable, Image, TextInput, Modal, StyleSheet, Linking, Dimensions, ImageBackground, ScrollView } from "react-native";
import { getFirestore, doc, updateDoc, setDoc, getDoc, getDocs, collection, query, where, arrayUnion } from "firebase/firestore";
import { useUser } from "../../Widgets/UserContext";
import { useIsFocused } from '@react-navigation/native';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ECardSelectionModal from "./eCards";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import Checkout from "./Checkout";
import ContributionFlow from "./ContributionFlow";
import { ConnectedAccountModal, ConnectedAccount } from "../PaymentProcessing/ConnectedAccount";
import defaultGoalImage from "../../assets/exGoal.jpg";
import exampleBackground1 from "../../assets/exBackground1.jpg";
import exampleBackground2 from "../../assets/exBackground2.jpg";
import exampleBackground3 from "../../assets/exBackground3.jpg";
import exampleBackground4 from "../../assets/exBackground4.jpg";
import exampleBackground5 from "../../assets/exBackground5.jpg";
import exampleBackground6 from "../../assets/exBackground6.jpg";
import exampleBackground7 from "../../assets/exBackground7.jpg";
import genericProfilePic from "../../assets/generic.jpg";
import stripeConfigService from "../../services/StripeConfigService";
import { Ionicons } from '@expo/vector-icons';
import { MYTASSEL_PLUS_FEATURES } from "../../constants/MyTasselPlus";
import useMyTasselPlus from "../../Hooks/useMyTasselPlus";
import GradFundGoalEditor from "../../Widgets/GradFundGoalEditor";
import GradFundGoalOnboarding from "../../Widgets/GradFundGoalOnboarding";
import { hasEstablishedGoalTarget, UNSET_GOAL_TARGET } from "../../utils/gradFundGoal";
import { emitSpotlightEvent, useEmitSpotlightEventWhenOpened } from "../../Widgets/SpotlightTutorial/spotlightBus";
import { SPOTLIGHT_EVENTS } from "../../Widgets/SpotlightTutorial/spotlightEventNames";
import { SPOTLIGHT_TARGETS, spotlightTarget, spotlightTargetWhen } from "../../Widgets/SpotlightTutorial/spotlightTargets";


const { width, height } = Dimensions.get('window');
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
const isSmallDesktop = width >= 1024 && width <= 1500;
const isLargeDesktop = width > 1500;

// Stripe key will be loaded dynamically from the configuration service


const defaultBackgrounds = [
	exampleBackground1,
	exampleBackground2,
	exampleBackground3,
	exampleBackground4,
	exampleBackground5,
	exampleBackground6,
	exampleBackground7,
];

const GoalTracker = ({ pageOwnerId, pageOwner, isOwner, isVisitorView = false, onHeightChange, targetHeight }) => {
	const db = getFirestore();
	const { currentUser, currentUserData } = useUser();
	const myTasselPlus = useMyTasselPlus();
	const isFocused = useIsFocused();
	const storage = getStorage();
	const [goalData, setGoalData] = useState({
		targetAmount: UNSET_GOAL_TARGET,
		amountContributed: 0,
		description: "",
		title: "",
		goalPictureURL: "",
		goalURL: "",
		accountURLs: [], // Changed from accountURL to accountURLs
		contributions: [],
	});



	const [showEditGoalModal, setShowEditGoalModal] = useState(false);
	useEmitSpotlightEventWhenOpened(showEditGoalModal, SPOTLIGHT_EVENTS.REGISTRY_GOAL_EDITOR_OPENED);
	const [editGoalData, setEditGoalData] = useState({ ...goalData });
	const [newGoalImage, setNewGoalImage] = useState(null);
	const [accountUrl, setAccountUrl] = useState("");
	const [showContributionModal, setShowContributionModal] = useState(false);
	const [showECardModal, setShowECardModal] = useState(false);
	const [contributionAmount, setContributionAmount] = useState("");
	const [pageOwnerEmail, setPageOwnerEmail] = useState("");
	const [showConnectedAccountModal, setShowConnectedAccountModal] = useState(false);
	const [showStripeSetupNoticeModal, setShowStripeSetupNoticeModal] = useState(false);

	const [showPaymentOptionsModal, setShowPaymentOptionsModal] = useState(false);
	const [showPostContributionModal, setShowPostContributionModal] = useState(false);

	const [selectedECard, setSelectedECard] = useState(null);
	const [showCheckoutModal, setShowCheckoutModal] = useState(false);
	const [stripePromise, setStripePromise] = useState(null);
	const [showContributionFlow, setShowContributionFlow] = useState(false);
// Stripe key will be loaded dynamically from the configuration service


	let LOCAL_SERVER_URL = "http://localhost:5001/my-tassel/us-central1/api";
	let FIREBASE_SERVER_URL = "https://us-central1-my-tassel.cloudfunctions.net/api";
	// Always use production Firebase Functions (no emulators)
	const SERVER_URL = FIREBASE_SERVER_URL;

	const [backgroundImage, setBackgroundImage] = useState(null);

	// Add state for button context
	const [showFinishSetupButton, setShowFinishSetupButton] = useState(false);
	const hasGoalTarget = hasEstablishedGoalTarget(goalData);
	const hasCompletedStripeSetup = Boolean(pageOwner?.stripeAccountId && pageOwner?.stripeSetupComplete);
	const isCurrentPageOwner = pageOwnerId === currentUserData?.uid;
	const shouldShowOwnerStripeNotice = isCurrentPageOwner && !isVisitorView && hasGoalTarget && !hasCompletedStripeSetup;

	const dismissStripeSetupNotice = () => {
		if (typeof window !== 'undefined') {
			sessionStorage.setItem(`stripeSetupNoticeDismissed_${pageOwnerId}`, 'true');
		}
		setShowStripeSetupNoticeModal(false);
	};

	// Initialize Stripe with dynamic configuration
	useEffect(() => {
		const initializeStripe = async () => {
			try {
				const publishableKey = await stripeConfigService.getPublishableKey();
				if (publishableKey) {
					setStripePromise(loadStripe(publishableKey));
				}
			} catch (error) {
				
			}
		};
		
		initializeStripe();

		// Listen for configuration changes and reinitialize
		const unsubscribe = stripeConfigService.addChangeListener(() => {
			
			initializeStripe();
		});

		return unsubscribe; // Cleanup listener on unmount
	}, []);

	// Check for cached stripeAccountId and Firestore status
	useEffect(() => {
		if (pageOwner && pageOwner.email) {
			const cachedStripeId = localStorage.getItem(`stripeAccountId_${pageOwner.email}`);
			const hasFirestoreStripeId = pageOwner?.stripeAccountId;

			console.log('GoalTracker Local Storage Debug:', {
				email: pageOwner.email,
				cachedStripeId,
				hasFirestoreStripeId,
				localStorageKey: `stripeAccountId_${pageOwner.email}`,
				allLocalStorage: { ...localStorage },
			});

			if (cachedStripeId && !hasFirestoreStripeId) {
				console.log('Should show Finish Setup button because:', {
					cachedStripeId,
					hasFirestoreStripeId
				});
				setShowFinishSetupButton(true);
			} else {
				setShowFinishSetupButton(false);
			}
		}
	}, [pageOwner]);

	useEffect(() => {
		if (pageOwner) {
			if (pageOwner.gradCardBackgroundImage) {
				setBackgroundImage(pageOwner.gradCardBackgroundImage);
			} else {
				setBackgroundImage(exampleBackground2);
			}
		}
	}, [pageOwner]);

	useEffect(() => {
		loadGoalData();
	}, [pageOwnerId]);

	// The setup modal is only ever opened here. It is closed solely by the user
	// (Skip for Now / Activate), never by data loading or re-renders.
	const needsGradFundActivation = isCurrentPageOwner && !isVisitorView && !hasCompletedStripeSetup;
	useEffect(() => {
		if (!pageOwner || !currentUserData || !needsGradFundActivation) return;
		if (typeof window !== 'undefined' && sessionStorage.getItem(`stripeSetupNoticeDismissed_${pageOwnerId}`)) return;

		setShowStripeSetupNoticeModal(true);
	}, [pageOwner, currentUserData, needsGradFundActivation, pageOwnerId]);

	const loadGoalData = async () => {
		const usersRef = collection(db, "users");
		const q = query(usersRef, where("uid", "==", pageOwnerId));
		const querySnapshot = await getDocs(q);

		if (!querySnapshot.empty) {
			querySnapshot.forEach((docSnap) => {
				const userData = docSnap.data();
				setPageOwnerEmail(userData.email);

				if (userData.pages?.registryPageConfig?.goalTracker) {
					const tracker = userData.pages.registryPageConfig.goalTracker;
					setGoalData({
						...tracker,
						targetAmount: hasEstablishedGoalTarget(tracker) ? tracker.targetAmount : UNSET_GOAL_TARGET,
					});
				} else {
					// Create an initial goal document
					const userDocRef = doc(db, "users", docSnap.id);
					setDoc(userDocRef, { pages: { registryPageConfig: { goalTracker: { ...goalData } } } }, { merge: true });
				}
			});
		} else {
			// 
		}
	};

	const handleEditGoal = () => {
		setEditGoalData({ ...goalData, targetAmount: hasGoalTarget ? String(goalData.targetAmount) : "" });
		setAccountUrl((goalData.accountURLs || []).filter(Boolean).join(", "));
		setShowEditGoalModal(true);
	};

	const handleImageChange = (event) => {
		const file = event.target.files[0];
		if (file && file.type.startsWith("image/")) {
			if (!myTasselPlus.canUseFeature(MYTASSEL_PLUS_FEATURES.GOAL_IMAGE)) {
				event.target.value = '';
				myTasselPlus.openUpsell(MYTASSEL_PLUS_FEATURES.GOAL_IMAGE);
				return;
			}
			setNewGoalImage(file);
		}
	};

	const uploadImage = async () => {
		if (newGoalImage) {
			const imageRef = ref(storage, `goalImages/${pageOwnerId}/${newGoalImage.name}`);
			await uploadBytes(imageRef, newGoalImage);
			const imageUrl = await getDownloadURL(imageRef);
			return imageUrl;
		}
		return goalData.goalPictureURL;
	};

	const getButtonLabel = (url) => {
		if (url.toLowerCase().includes("venmo")) return "Venmo";
		if (url.toLowerCase().includes("paypal")) return "PayPal";
		if (url.toLowerCase().includes("zelle")) return "Zelle";
		return "Contribute"; // Default label
	};

	const handleSubmitEditGoal = async (resetContributions = false) => {
		const imageUrl = await uploadImage();
		const parsedTargetAmount = parseFloat(editGoalData.targetAmount) || UNSET_GOAL_TARGET;
		const sanitizedTargetAmount = parsedTargetAmount > 0 ? Math.max(1, parsedTargetAmount) : UNSET_GOAL_TARGET;
		const sanitizedAccountURLs = accountUrl
			? accountUrl.split(",").map((url) => url.trim()).filter(Boolean)
			: (goalData.accountURLs || []);
		const updatedGoalData = {
			...editGoalData,
			targetAmount: sanitizedTargetAmount,
			goalPictureURL: imageUrl,
			accountURLs: sanitizedAccountURLs,
			amountContributed: resetContributions ? 0 : goalData.amountContributed,
		};
		const usersRef = collection(db, "users");
		const q = query(usersRef, where("uid", "==", pageOwnerId));
		const querySnapshot = await getDocs(q);
		if (!querySnapshot.empty) {
			for (const docSnapshot of querySnapshot.docs) {
				const userDocRef = doc(db, "users", docSnapshot.id);
				await updateDoc(userDocRef, {
					"pages.registryPageConfig.goalTracker": updatedGoalData,
				});
			}
		}
		setGoalData(updatedGoalData);
		setShowEditGoalModal(false);
		emitSpotlightEvent(SPOTLIGHT_EVENTS.REGISTRY_GOAL_SAVED);
	};

	const handleResetTargetAmount = async () => {
		const confirmed = window.confirm("Reset your Grad Fund target amount? You can set a new one at any time. Funds already received won't be affected.");
		if (!confirmed) return;
		try {
			const usersRef = collection(db, "users");
			const q = query(usersRef, where("uid", "==", pageOwnerId));
			const querySnapshot = await getDocs(q);
			if (querySnapshot.empty) {
				alert("Could not find your account. Please refresh and try again.");
				return;
			}
			for (const docSnapshot of querySnapshot.docs) {
				const userDocRef = doc(db, "users", docSnapshot.id);
				await updateDoc(userDocRef, {
					"pages.registryPageConfig.goalTracker.targetAmount": UNSET_GOAL_TARGET,
				});
			}
			setGoalData((prev) => ({ ...prev, targetAmount: UNSET_GOAL_TARGET }));
			setEditGoalData((prev) => ({ ...prev, targetAmount: "" }));
			setShowEditGoalModal(false);
		} catch (error) {
			alert("Failed to reset your Grad Fund target amount: " + error.message);
		}
	};

	const closeStripeSetupModal = () => {
		if (showStripeSetupNoticeModal) dismissStripeSetupNotice();
		setShowConnectedAccountModal(false);
	};

	const handleGoalFieldChange = (field, value) => {
		setEditGoalData((prev) => ({ ...prev, [field]: value }));
	};

	const handleMakeContribution = () => {
		setShowContributionFlow(true); // Show new modern contribution flow
	};

	const handleECardSelection = (eCardData) => {
		// Assuming eCardData contains the selected e-card information
		setSelectedECard(eCardData); // Save the selected e-card data
		setShowECardModal(false); // Hide the e-card selection modal
		setShowCheckoutModal(true); // Show the checkout modal
	};

	const submitContribution = async () => {
		const newAmount = parseFloat(contributionAmount) || 0;
		const updatedAmount = parseFloat(goalData.amountContributed || 0) + newAmount;

		// Query to get the user's document reference based on UID
		const usersRef = collection(db, "users");
		const q = query(usersRef, where("uid", "==", pageOwnerId));
		const querySnapshot = await getDocs(q);

		if (!querySnapshot.empty) {
			querySnapshot.forEach(async (docSnapshot) => {
				const userDocRef = doc(db, "users", docSnapshot.id);

				// Update only the amountContributed field
				await updateDoc(userDocRef, {
					"pages.registryPageConfig.goalTracker.amountContributed": updatedAmount
				});

				// Add the contribution to the contributions array
				await updateDoc(userDocRef, {
					"pages.registryPageConfig.goalTracker.contributions": arrayUnion({
						amount: newAmount,
						contributorName: currentUserData?.firstName + " " + currentUserData?.lastName,
						contributorId: currentUserData?.uid,
						timestamp: new Date()
					})
				});
			});
		}

		// Update local state
		setGoalData(prevData => ({
			...prevData,
			amountContributed: updatedAmount
		}));

		setShowContributionModal(false);
		setContributionAmount("");
	};

	// Placeholder for initiating Stripe payment processing on the server
	const processStripePayment = async (amount) => {
		try {
			const response = await fetch(`${SERVER_URL}/create-payment-intent`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					amount: amount,
					currency: "usd", // Example currency, adjust as necessary
					pageOwner: pageOwner,
				}),
			});

			if (!response.ok) throw new Error("Network response was not ok");

			const result = await response.json();

			// Handle success or failure based on the server's response
			if (result.success) {
				// 
				// Update UI or state as necessary
			} else {
				
				// Handle failure, update UI or state as necessary
			}
		} catch (error) {
			
			// Handle error, update UI or state as necessary
		}
	};
	// Example usage within a component method, e.g., when a button is clicked
	const handlePaymentSubmission = () => {
		const amountToCharge = parseFloat(contributionAmount); // Ensure this is a valid number
		processStripePayment(amountToCharge);
	};

	const sendContributionEmail = async (contributionDetails) => {
		try {
			const response = await fetch(`${SERVER_URL}/send-contribution-email`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					...contributionDetails,
					pageOwner, // Include this in the request
				}),
			});

			if (response.ok) {
				// 
			} else {
				
			}
		} catch (error) {
			
		}
	};

	const PaymentOptionsModal = ({ visible, onClose, accountURLs }) => {
		const handlePaymentOptionSelect = async (url) => {
			// Ensure the URL starts with http:// or https://
			const formattedUrl = url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;

			const supported = await Linking.canOpenURL(formattedUrl);
			if (supported) {
				await Linking.openURL(formattedUrl);
				onClose(); // Close the payment options modal
				setShowPostContributionModal(true); // Show post-contribution modal
			} else {
				
			}
		};

		if (!visible) {
			return null;
		}

		return (
			<View style={styles.blurredContainer} visible={visible} onRequestClose={onClose}>
				<View style={styles.modalContent}>
					{accountURLs.map((url, index) => (
						<Pressable key={index} style={styles.buttonGreen} onPress={() => handlePaymentOptionSelect(url)}>
							<Text style={styles.buttonText}>{getButtonLabel(url)}</Text>
						</Pressable>
					))}
					<Pressable style={styles.buttonRed} onPress={onClose}>
						<Text style={styles.buttonText}>Close</Text>
					</Pressable>
				</View>
			</View>
		);
	};

	const PostContributionModal = ({ visible, onClose, onSubmitContribution }) => {
		const [tempContributionAmount, setTempContributionAmount] = useState("");

		return (
			<Modal style={{ ...styles.blurredContainer }} visible={visible} transparent={true} onRequestClose={onClose}>
				<View style={styles.modalContent}>
					<Text style={styles.text}>How much did you contribute?</Text>
					<TextInput style={styles.input} placeholder="Contribution amount" keyboardType="numeric" value={tempContributionAmount} onChangeText={setTempContributionAmount} />
					<Pressable style={styles.buttonGreen} onPress={() => onSubmitContribution(parseFloat(tempContributionAmount) || 0)}>
						<Text style={styles.buttonText}>Submit</Text>
					</Pressable>
					<Pressable style={styles.buttonRed} onPress={onClose}>
						<Text style={styles.buttonText}>Close</Text>
					</Pressable>
				</View>
			</Modal>
		);
	};

	return (
		<View style={styles.scrollView}>
			<View
				style={styles.container}
				{...spotlightTarget(SPOTLIGHT_TARGETS.REGISTRY_GOAL_TRACKER)}
				onLayout={(e) => onHeightChange && onHeightChange(e.nativeEvent.layout.height)}
			>
			<ImageBackground
				source={{ uri: backgroundImage }}
				imageStyle={{ ...styles.goalTrackerImage, borderRadius: 25 }}
				style={{
					...styles.goalTrackerContainer,
					borderRadius: 25,
					overflow: 'hidden',
					...(!isMobile && !isTablet && targetHeight ? { height: targetHeight, minHeight: targetHeight, maxHeight: targetHeight } : {}),
				}}
			>
				<Image
					source={goalData.goalPictureURL ? { uri: goalData.goalPictureURL } : { uri: "https://images.unsplash.com/photo-1579621970795-87facc2f976d?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" }}
					style={[
						styles.goalImage,
						(!isMobile && !isTablet && targetHeight ? { flex: 1, height: undefined, aspectRatio: undefined } : {}),
					]}
					resizeMode="cover"
				/>
			<Text style={styles.title}>{goalData.title}</Text>
			<Text style={styles.description} numberOfLines={3} ellipsizeMode="tail">{goalData.description}</Text>
		{isCurrentPageOwner && !isVisitorView && !hasGoalTarget && <GradFundGoalOnboarding />}
		{/* Show contribution amounts and progress only to page owners and other graduates */}
		{!isVisitorView && hasGoalTarget && (
			(pageOwnerId === currentUserData?.uid) || 
			(currentUserData?.accountType === "Graduate" || currentUserData?.accountType === "G") ? (
				<Text style={styles.amount}>
					${goalData.amountContributed} of ${goalData.targetAmount}
				</Text>
			) : (
				<Text style={styles.amount}>
					Graduation Fund: ${goalData.targetAmount}
				</Text>
			)
		)}
		{!isVisitorView && hasGoalTarget && (
			<View style={styles.contributionBar}>
				<View style={{ ...styles.filledBar, width: `${Math.min((goalData.amountContributed / goalData.targetAmount) * 100, 100)}%` }} />
			</View>
		)}
			{pageOwnerId === currentUserData?.uid && !isVisitorView ? (
			<Pressable style={styles.button} onPress={handleEditGoal} {...spotlightTarget(SPOTLIGHT_TARGETS.REGISTRY_GOAL_SET)}>
				<Text style={styles.buttonText}>{hasGoalTarget ? 'Edit Graduation Fund' : 'Set Your Goal'}</Text>
			</Pressable>
			) : (
				hasGoalTarget && hasCompletedStripeSetup ? (
					<Pressable style={styles.button} onPress={handleMakeContribution}>
						<Text style={styles.buttonText}>Make a Contribution</Text>
					</Pressable>
				) : hasGoalTarget ? (
				<View style={styles.contributionNotReadyContainer}>
					<Ionicons name="lock-closed" size={28} color="#4c956c" style={{ marginBottom: 6 }} />
					<Text style={styles.contributionNotReadyTitle}>Contributions coming soon</Text>
					<Text style={styles.contributionNotReadyText}>This graduate hasn't finished setting up contributions yet. Check back later!</Text>
					</View>
				) : (
					<View style={styles.noGoalContainer}>
						<Text style={styles.noGoalText}>This graduate hasn't set up their graduation fund yet. Please check back later.</Text>
					</View>
				)
			)}
			{shouldShowOwnerStripeNotice && (
				<View style={styles.setupNoticeContainer}>
					<Text style={styles.setupNoticeTitle}>Activate your Grad Fund to start receiving payments</Text>
					<Text style={styles.setupNoticeText}>Your Graduation Fund won't accept payments until Stripe confirms your account is fully set up.</Text>
					<Pressable style={styles.setupNoticeButton} onPress={() => pageOwner && setShowConnectedAccountModal(true)} {...spotlightTarget(SPOTLIGHT_TARGETS.REGISTRY_GOAL_ACTIVATE)}>
						<Text style={styles.buttonText}>{pageOwner?.stripeAccountId ? 'Finish Stripe Setup' : 'Activate Your Grad Fund'}</Text>
					</Pressable>
				</View>
			)}
			{pageOwnerId === currentUserData?.uid && !pageOwner?.stripeAccountId && !isVisitorView && !shouldShowOwnerStripeNotice &&
				<Pressable style={styles.button} onPress={() => pageOwner && setShowConnectedAccountModal(true)} {...spotlightTarget(SPOTLIGHT_TARGETS.REGISTRY_GOAL_ACTIVATE)}>
					<Text style={styles.buttonText}>Activate Your Grad Fund</Text>
				</Pressable>
			}
			{pageOwnerId === currentUserData?.uid && pageOwner?.stripeAccountId && !isVisitorView && !shouldShowOwnerStripeNotice &&
				<Pressable 
					style={[styles.button, { backgroundColor: hasCompletedStripeSetup ? '#4c956c' : '#c77d1a', marginTop: 10 }]} 
					onPress={() => pageOwner && setShowConnectedAccountModal(true)}
					{...spotlightTargetWhen(!hasCompletedStripeSetup, SPOTLIGHT_TARGETS.REGISTRY_GOAL_ACTIVATE)}
				>
					<Text style={styles.buttonText}>{hasCompletedStripeSetup ? 'Manage Stripe Account' : 'Finish Stripe Setup'}</Text>
				</Pressable>
			}

			{/* MODALS */}
			{/* Edit Graduation Fund Modal */}
			{showEditGoalModal && (
				<View style={styles.goalEditorOverlay}>
					<ScrollView contentContainerStyle={styles.goalEditorScrollContent}>
						<GradFundGoalEditor
							title={editGoalData.title}
							description={editGoalData.description}
							targetAmount={String(editGoalData.targetAmount ?? "")}
							onChangeField={handleGoalFieldChange}
							onSave={() => handleSubmitEditGoal()}
							onCancel={() => setShowEditGoalModal(false)}
							onResetTarget={handleResetTargetAmount}
							canResetTarget={hasGoalTarget}
							descriptionMaxLength={120}
							amountRaised={goalData.amountContributed}
							photoLabel={`Upload Photo ${!myTasselPlus.hasPlus ? "+" : ""}`}
							onRequestPhoto={(openPhotoPicker) => myTasselPlus.requireFeature(MYTASSEL_PLUS_FEATURES.GOAL_IMAGE, openPhotoPicker)}
							onPhotoSelected={handleImageChange}
							photoMessage={newGoalImage ? { type: "success", text: `Selected: ${newGoalImage.name}` } : null}
						/>
					</ScrollView>
				</View>
			)}
			{/* Contribution Modal */}
			<ECardSelectionModal
				isVisible={showECardModal}
				onSelect={handleECardSelection}
				onClose={() => setShowECardModal(false)}
			/>

			{/* Checkout Modal (Legacy) */}
			{pageOwner &&

				<Elements stripe={stripePromise}>
					<Checkout
						isVisible={showCheckoutModal}
						onClose={() => setShowCheckoutModal(false)}
						onContribute={(contributionAmount) => {
							// 
							// setSelectedECard(null);
						}}
						selectedECard={selectedECard} pageOwner={pageOwner}
					/>
				</Elements>
			}

			{/* Modern Stepwise Contribution Flow */}
			{pageOwner && stripePromise && (
				<Elements stripe={stripePromise}>
					<ContributionFlow
						isVisible={showContributionFlow}
						onClose={() => setShowContributionFlow(false)}
						pageOwner={pageOwner}
					/>
				</Elements>
			)}

			{/* Show Payment Options Modal */}
			<PaymentOptionsModal visible={showPaymentOptionsModal} onClose={() => setShowPaymentOptionsModal(false)} accountURLs={goalData.accountURLs} />

			{/* Show Post Contribution Modal */}
			<PostContributionModal visible={showPostContributionModal} onClose={() => setShowPostContributionModal(false)} onSubmitContribution={submitContribution} />

			{/* Show Connected Account Modal */}
			{pageOwner && ((isOwner && showConnectedAccountModal) || (showStripeSetupNoticeModal && isFocused)) &&
				<>
					<ConnectedAccount pageOwner={pageOwner} />
					<ConnectedAccountModal
						visible
						onClose={closeStripeSetupModal}
						pageOwner={pageOwner}
					/>
				</>
			}
			{myTasselPlus.upsellModal}

		</ImageBackground>
			</View>
		</View>
	);
};

const fontFamilies = {
	Bodoni72Smallcaps: "Bodoni72Smallcaps",
};

const styles = StyleSheet.create({
	scrollView: {
		flex: 1,
	},
	container: {
		flex: 1,
		padding: isMobile ? 8 : isTablet ? 12 : isSmallDesktop ? 15 : 20,
		justifyContent: "flex-start",
		alignItems: "center",
		width: "100%",
		minHeight: isMobile ? undefined : 650,
		maxHeight: isMobile ? undefined : 650,
		minWidth: isMobile ? undefined : isSmallDesktop ? 400 : 450,
		maxWidth: "100%",
	},
	goalTrackerContainer: {
		backgroundColor: "#fefde2",
		padding: isMobile ? 8 : isTablet ? 12 : isSmallDesktop ? 15 : 20,
		borderRadius: 25,
		width: isMobile ? '100%' : isTablet ? '90%' : isSmallDesktop ? 380 : 400,
		minHeight: isMobile ? undefined : 650,
		maxWidth: isMobile ? '100%' : isTablet ? '90%' : isSmallDesktop ? 380 : 400,
		alignSelf: 'center',
		marginTop: 0,
		marginBottom: 0,
		marginHorizontal: 'auto',
		overflow: "hidden",
	},
	header: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 24 : isTablet ? 32 : 50,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		paddingBottom: isMobile ? 10 : 25,
	},
	goalImage: {
		width: isMobile || isTablet ? '100%' : 350,
		height: isMobile || isTablet ? 'auto' : 350,
		aspectRatio: isMobile || isTablet ? 1.5 : undefined,
		resizeMode: "cover",
		borderRadius: 25,
	},
	button: {
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 40,
		paddingVertical: 10,
		paddingHorizontal: 20,
		marginVertical: 10,
	},
	 buttonText: {
	 	fontFamily: "Orpheus Pro",
	 	fontSize: isMobile ? 16 : 18,
	 	textAlign: "center",
	 	color: "#e4e4e4",
	 	textShadowOffset: { width: isMobile ? 1 : 3, height: isMobile ? 1 : 3 },
	 	textShadowRadius: isMobile ? 3 : 6,
	 	textShadowColor: "rgba(0, 0, 0, 0.09)",
	 	marginHorizontal: isMobile ? 16 : 25,
	 },
	title: {
		fontSize: 24,
		fontWeight: "bold",
		marginBottom: 10,
		marginTop: 20,
		color: "#e4e4e4",
	},
	description: {
		fontSize: 18,
		marginBottom: 10,
		color: "#e4e4e4",
	},
	amount: {
		fontSize: 16,
		marginBottom: 10,
		color: "#e4e4e4",
	},
	contributionBar: {
		height: 20,
		backgroundColor: "#ddd",
		borderRadius: 10,
		marginBottom: 10,
	},
	filledBar: {
		height: "100%",
		backgroundColor: "#4c956c",
		borderRadius: 10,
	},
	contribution: {
		flexDirection: "row",
		alignItems: "center",
		marginBottom: 10,
	},
	profilePic: {
		width: 50,
		height: 50,
		borderRadius: 25,
		marginRight: 10,
	},
	modalContent: {
		padding: 20,
		backgroundColor: "#fefde2",
		borderRadius: 10,
	},
	input: {
		borderWidth: 1,
		borderColor: "#ddd",
		padding: 10,
		fontSize: 18,
		borderRadius: 10,
		marginVertical: 10,
		backgroundColor: "#fff",
	},
	blurredContainer: {
		// Apply a blur effect
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backdropFilter: "blur(10px)", // Apply blur effect
	},
	modalContent: {
		padding: 20,
		backgroundColor: "#fefde2", // Consider using a color that matches your app's theme
		borderRadius: 10,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		margin: 20, // Ensures modal doesn't stretch to the edges of the screen
		alignItems: "center", // Centers the modal's content
	},
	input: {
		borderWidth: 1,
		borderColor: "#ddd",
		padding: 10,
		fontSize: 18,
		borderRadius: 10,
		marginVertical: 10,
		width: "100%", // Ensures consistent width for all inputs
		backgroundColor: "#fefde2", // Matches the container's background for cohesion
	},
	buttonGreen: {
		backgroundColor: "#4c956c",
		paddingVertical: 10,
		paddingHorizontal: 20,
		borderRadius: 20,
		marginTop: 10,
		width: "80%", // Adjusts button width to match modal's width
		alignItems: "center", // Ensures text is centered within the button
	},
	buttonRed: {
		backgroundColor: "red",
		paddingVertical: 10,
		paddingHorizontal: 20,
		borderRadius: 20,
		marginTop: 10,
		width: "80%", // Adjusts button width to match modal's width
		alignItems: "center", // Ensures text is centered within the button
	},
	inputLabel: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		color: "#333", // Ensures the label is visible and clear
		marginVertical: 5, // Adds spacing around the label for clarity
	},
	text: {
		fontFamily: "Orpheus Pro",
		fontSize: 18,
		textAlign: "center",
		color: "#4c956c",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
	},
	noGoalContainer: {
		alignItems: "center",
		justifyContent: "center",
		paddingVertical: 20,
		paddingHorizontal: 10,
	},
	noGoalText: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		textAlign: "center",
		color: "#e4e4e4",
	},
	contributionNotReadyContainer: {
		backgroundColor: "rgba(254, 253, 226, 0.88)",
		borderRadius: 12,
		paddingVertical: 18,
		paddingHorizontal: 16,
		marginVertical: 10,
		width: "100%",
		alignItems: "center",
	},
	contributionNotReadyTitle: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		fontWeight: "700",
		color: "#2f5138",
		textAlign: "center",
		marginBottom: 6,
	},
	contributionNotReadyText: {
		fontFamily: "Orpheus Pro",
		fontSize: 14,
		color: "#4b5563",
		textAlign: "center",
		lineHeight: 20,
	},
	setupNoticeContainer: {
		backgroundColor: "rgba(254, 253, 226, 0.92)",
		borderRadius: 12,
		padding: 14,
		marginTop: 8,
		width: "100%",
		alignItems: "center",
	},
	setupNoticeTitle: {
		fontSize: 16,
		fontWeight: "700",
		color: "#2f5138",
		textAlign: "center",
		marginBottom: 6,
	},
	setupNoticeText: {
		fontSize: 14,
		color: "#4b5563",
		textAlign: "center",
		lineHeight: 20,
	},
	setupNoticeButton: {
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 24,
		paddingVertical: 10,
		paddingHorizontal: 18,
		marginTop: 12,
		width: "100%",
	},
	goalEditorOverlay: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backdropFilter: "blur(10px)",
	},
	goalEditorScrollContent: {
		flexGrow: 1,
		justifyContent: "center",
		alignItems: "center",
		padding: 16,
	},
});

export default GoalTracker;
